import {Injectable} from '@angular/core';
import {DocumentDataService} from './documentData.service';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {DocumentSummaryModel} from '../../../api/model/documentSummary.model';
import {DocumentSummaryConverter} from '../../../api/converter/DocumentSummary.converter';
import {DocumentModel} from '../../../api/model/document.model';

@Injectable({ providedIn: 'root' })
export class DocumentSummaryDataServiceAdapter extends
    AbstractDataServiceDtoSummaryAdapter<DocumentSummaryModel, DocumentSummaryConverter, DocumentModel> {
    constructor(dataService: DocumentDataService, converter: DocumentSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): DocumentModel {
        return new DocumentModel();
    }
}
